/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { getJobRoomData, getTopologyRoomData } from "../multiplayer/SocketConnection";
import { JOB_ROOM, TOPOLOGY_ROOM } from "../rooms/RoomNameConstants";
import { resetInitialGraphState, setCenterGraph, setIsLoading } from "../store/slice/centerGraphSlice";
import { setOpenedKPI } from "../store/slice/roomSlices/homeSlice";
import { setSelectedJob } from "../store/slice/roomSlices/jobRoomSlice";
import { changeRoomHandler } from "./ChangeRoomHandlers";
import store from "../store/store";

const jobRoomSetup = (engineList, selectedJob, dispatch) => {
    getJobRoomData({
        engineList,
        selectedJob,
        targetRoom: JOB_ROOM
    });

    // prepare job room data, targetRoom have the reference of redux store
    getTopologyRoomData({
        selectedJob,
        targetRoom: TOPOLOGY_ROOM
    });

    dispatch(setSelectedJob(selectedJob));
    dispatch(resetInitialGraphState());
    dispatch(setIsLoading(true));
    dispatch(setOpenedKPI({ opened: null }));
}

export const handleGoToJobRoom = (selectedJob) => {
    let engines = []

    const state = store.getState()
    const dispatch = store.dispatch

    const engineList = state.user.engines.list
    const selectedEngines = state.user.engines.selected;

    selectedEngines.forEach((engineName) => {
        engines.push(...engineList.filter((engine) => engine.name === engineName))
    });

    const dataToCache = {
        key: "centerGraph",
        data: state.centerGraph,
        callback: (cachedData) => {
            dispatch(setCenterGraph(cachedData))
        },
    }

    changeRoomHandler(
        JOB_ROOM,
        jobRoomSetup(engines, selectedJob, dispatch),
        dataToCache
    )
}